export default __webpack_public_path__ + "static/media/remove-button.d2cc497c.svg";